"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Root = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _provider = _interopRequireDefault(require("@emotion/provider"));

var _theme = require("../theme");

var _mobile = _interopRequireDefault(require("./mobile"));

var _desktop = _interopRequireDefault(require("./desktop"));

var Root =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e7rfqu0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.mainBackground,
    fontFamily: theme.mainTextFace,
    color: theme.mainTextColor,
    fontSize: theme.mainTextSize
  };
}, function (_ref2) {
  var isMobileDevice = _ref2.isMobileDevice;
  return isMobileDevice ? {
    display: 'block',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    overflow: 'auto'
  } : {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    overflow: 'hidden'
  };
});
exports.Root = Root;
var StoriesPanelInner =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "e7rfqu1"
})({
  flexGrow: 1,
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'auto'
});

var Layout = function Layout(props) {
  var isMobileDevice = props.isMobileDevice,
      theme = props.theme,
      AddonPanel = props.addonPanel,
      StoriesPanel = props.storiesPanel,
      Preview = props.preview,
      ShortcutsHelp = props.shortcutsHelp,
      SearchBox = props.searchBox;
  return _react.default.createElement(_provider.default, {
    theme: theme || _theme.normal
  }, _react.default.createElement("div", null, _react.default.createElement(Root, {
    isMobileDevice: isMobileDevice
  }, isMobileDevice ? _react.default.createElement(_mobile.default, null, _react.default.createElement(StoriesPanelInner, null, _react.default.createElement(StoriesPanel, null)), _react.default.createElement(StoriesPanelInner, null, _react.default.createElement(Preview, null)), _react.default.createElement(AddonPanel, null)) : _react.default.createElement(_desktop.default, props)), _react.default.createElement(ShortcutsHelp, null), _react.default.createElement(SearchBox, null)));
};

Layout.propTypes = {
  theme: _propTypes.default.shape({}),
  showStoriesPanel: _propTypes.default.bool.isRequired,
  showAddonPanel: _propTypes.default.bool.isRequired,
  goFullScreen: _propTypes.default.bool.isRequired,
  storiesPanel: _propTypes.default.func.isRequired,
  preview: _propTypes.default.func.isRequired,
  addonPanel: _propTypes.default.func.isRequired,
  shortcutsHelp: _propTypes.default.func.isRequired,
  searchBox: _propTypes.default.func.isRequired,
  addonPanelInRight: _propTypes.default.bool.isRequired,
  isMobileDevice: _propTypes.default.bool.isRequired
};
Layout.defaultProps = {
  theme: null
};
var _default = Layout;
exports.default = _default;